module.exports = __webpack_public_path__ + "img/Intelligent.18be345f.png";